export const heroComics = [
  {
    id: 1,
    title: '秘密教学',
    subtitle: '韩漫人气榜TOP1',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%2C%20romance%20genre%2C%20two%20characters%20facing%20each%20other%20with%20dramatic%20lighting%2C%20clean%20minimal%20background%20with%20warm%20peach%20tones%2C%20modern%20webtoon%20illustration%2C%20soft%20color%20palette%2C%20cinematic%20composition&width=400&height=560&seq=hero-comic-01&orientation=portrait',
    category: '热门韩漫',
    tag: '连载中',
    tagColor: 'accent',
  },
  {
    id: 2,
    title: '她的秘密',
    subtitle: '全网首发无删减',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%2C%20drama%20romance%2C%20female%20protagonist%20close-up%20portrait%2C%20moody%20atmospheric%20lighting%2C%20warm%20amber%20and%20cream%20background%2C%20soft%20dreamlike%20aesthetic%2C%20webtoon%20art%20style%2C%20emotional%20expression&width=400&height=560&seq=hero-comic-02&orientation=portrait',
    category: '独家资源',
    tag: '无删减',
    tagColor: 'primary',
  },
  {
    id: 3,
    title: '狂野之夜',
    subtitle: '每日更新中',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20mature%20romance%20genre%2C%20couple%20silhouette%20against%20city%20night%20skyline%2C%20dramatic%20warm%20orange%20and%20coral%20gradient%20background%2C%20modern%20stylish%20webtoon%20illustration%2C%20elegant%20composition&width=400&height=560&seq=hero-comic-03&orientation=portrait',
    category: '每日大赛',
    tag: '更新中',
    tagColor: 'accent',
  },
];

export const featuredComics = [
  {
    id: 1,
    title: '韩漫分类大全',
    subtitle: '恋爱 / 剧情 / 悬疑 / 奇幻',
    icon: 'ri-book-open-line',
    bgStyle: 'dark',
  },
  {
    id: 2,
    title: '明星塌房内幕',
    subtitle: '网红反差 · 独家吃瓜',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%2C%20mystery%20drama%20scene%2C%20two%20characters%20in%20tense%20confrontation%2C%20warm%20golden%20hour%20lighting%2C%20soft%20atmospheric%20background%20with%20blurred%20cityscape%2C%20cinematic%20composition%2C%20manga%20art%20style&width=600&height=800&seq=featured-comic-02&orientation=portrait',
    bgStyle: 'image',
    tag: '吃瓜',
  },
  {
    id: 3,
    title: '歪歪独家资源',
    subtitle: '无遮羞 · 无删减 · 无遮挡',
    coverImage: 'https://readdy.ai/api/search-image?query=Stylized%20abstract%20geometric%20composition%20with%20warm%20coral%20and%20cream%20tones%2C%20minimal%20art%20illustration%2C%20soft%20gradients%2C%20modern%20poster%20style%2C%20elegant%20simple%20design%2C%20texture%20overlay&width=600&height=600&seq=featured-comic-03&orientation=squarish',
    bgStyle: 'text',
  },
];

export const hotComics = [
  {
    id: 1,
    title: '邻居人妻',
    chapter: '更新至第89话',
    tag: '热门',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%2C%20close-up%20of%20female%20character%20with%20flowing%20hair%2C%20soft%20warm%20lighting%2C%20cream%20and%20peach%20background%2C%20elegant%20webtoon%20art%20style%2C%20emotional%20expression%2C%20dreamy%20atmosphere&width=400&height=560&seq=hot-comic-01&orientation=portrait',
  },
  {
    id: 2,
    title: '办公室秘密',
    chapter: '更新至第56话',
    tag: '新番',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20cover%2C%20male%20and%20female%20characters%20in%20business%20attire%2C%20modern%20stylish%20illustration%2C%20warm%20amber%20lighting%2C%20clean%20minimal%20background%2C%20webtoon%20art%20style%2C%20professional%20yet%20romantic&width=400&height=560&seq=hot-comic-02&orientation=portrait',
  },
  {
    id: 3,
    title: '深夜便利店',
    chapter: '更新至第34话',
    tag: '推荐',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20character%20at%20convenience%20store%20at%20night%2C%20warm%20neon%20lighting%2C%20atmospheric%20mood%2C%20soft%20color%20palette%2C%20webtoon%20illustration%20style%2C%20cozy%20vibe&width=400&height=560&seq=hot-comic-03&orientation=portrait',
  },
  {
    id: 4,
    title: '契约婚姻',
    chapter: '更新至第112话',
    tag: '完结',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20romance%20cover%2C%20wedding%20theme%2C%20elegant%20characters%20in%20formal%20wear%2C%20soft%20golden%20lighting%2C%20cream%20and%20champagne%20background%2C%20sophisticated%20webtoon%20art%20style%2C%20emotional%20depth&width=400&height=560&seq=hot-comic-04&orientation=portrait',
  },
];

export const platformFeatures = [
  {
    id: 1,
    icon: 'ri-lock-unlock-line',
    title: '完全无删减',
    description: '原版韩漫完整呈现，拒绝任何删减修改',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    description: '韩漫资源每日同步，抢先全网首发',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '全端适配',
    description: '手机电脑平板无缝切换，随时随地畅读',
  },
  {
    id: 4,
    icon: 'ri-eye-off-line',
    title: '隐私保护',
    description: '阅读记录完全加密，你的隐私我们守护',
  },
  {
    id: 5,
    icon: 'ri-vip-crown-line',
    title: '永久免费',
    description: '所有漫画资源完全免费，零门槛畅享',
  },
];

export const userReviews = [
  {
    id: 1,
    name: '小橘子',
    role: '资深韩漫读者 · 3年漫龄',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20female%20character%20portrait%2C%20young%20woman%20with%20warm%20smile%2C%20soft%20peach%20and%20cream%20background%2C%20simple%20minimal%20illustration%2C%20clean%20anime%20art%20style%2C%20friendly%20expression&width=400&height=400&seq=review-avatar-01&orientation=squarish',
    quote: '歪歪漫画真的是我见过更新最快的韩漫网站了！每天都有新内容，而且画质超级清晰，阅读体验一流。推荐给所有喜欢韩漫的朋友！',
  },
  {
    id: 2,
    name: '吃瓜群众阿强',
    role: '吃瓜达人 · 八卦前线',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20male%20character%20portrait%2C%20young%20man%20with%20cool%20expression%2C%20simple%20warm%20beige%20background%2C%20minimal%20illustration%20style%2C%20modern%20anime%20art%2C%20casual%20vibe&width=400&height=400&seq=review-avatar-02&orientation=squarish',
    quote: '不光是漫画！这里的吃瓜板块才是真的宝藏，明星塌房、网红反差，全都是全网首发。每天必刷，不然就out了！',
  },
  {
    id: 3,
    name: '漫迷小美',
    role: '韩漫重度爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20female%20character%20portrait%2C%20cute%20young%20woman%20with%20glasses%2C%20warm%20peach%20background%2C%20simple%20clean%20illustration%2C%20friendly%20anime%20art%20style%2C%20gentle%20expression&width=400&height=400&seq=review-avatar-03&orientation=squarish',
    quote: '从其他平台转过来的，直接被圈粉了！无删减的韩漫资源太全了，而且完全免费，简直是我们漫迷的福音啊！',
  },
];

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '韩漫大全', href: '#featured' },
  { label: '热门排行', href: '#hot' },
  { label: '每日大赛', href: '#features' },
  { label: '吃瓜基地', href: '#reviews' },
];

export const footerLinks = {
  comicCategories: {
    title: '漫画分类',
    links: [
      { label: '恋爱韩漫', href: '#' },
      { label: '剧情韩漫', href: '#' },
      { label: '悬疑韩漫', href: '#' },
      { label: '奇幻韩漫', href: '#' },
    ],
  },
  quickLinks: {
    title: '快速入口',
    links: [
      { label: '歪歪漫画入口', href: '#' },
      { label: '免费漫画', href: '#' },
      { label: '每日更新', href: '#' },
      { label: '热门排行', href: '#' },
    ],
  },
  resources: {
    title: '资源中心',
    links: [
      { label: '韩漫推荐', href: '#' },
      { label: '新番速递', href: '#' },
      { label: '完结漫画', href: '#' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '关于歪歪', href: '#' },
      { label: '隐私政策', href: '#' },
      { label: '用户协议', href: '#' },
      { label: '联系我们', href: '#' },
    ],
  },
};